import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

export const Search = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      d="M17.3311 16.5156L13.7242 12.9095C14.7696 11.6544 15.2909 10.0445 15.1797 8.41486C15.0684 6.7852 14.3331 5.26116 13.1268 4.15979C11.9205 3.05843 10.336 2.46453 8.70299 2.50164C7.06995 2.53875 5.51409 3.20402 4.35906 4.35906C3.20402 5.51409 2.53875 7.06995 2.50164 8.70299C2.46453 10.336 3.05843 11.9205 4.15979 13.1268C5.26116 14.3331 6.7852 15.0684 8.41486 15.1797C10.0445 15.2909 11.6544 14.7696 12.9095 13.7242L16.5156 17.3311C16.5692 17.3847 16.6328 17.4271 16.7027 17.4561C16.7727 17.4851 16.8477 17.5 16.9234 17.5C16.9991 17.5 17.0741 17.4851 17.144 17.4561C17.214 17.4271 17.2776 17.3847 17.3311 17.3311C17.3847 17.2776 17.4271 17.214 17.4561 17.144C17.4851 17.0741 17.5 16.9991 17.5 16.9234C17.5 16.8477 17.4851 16.7727 17.4561 16.7027C17.4271 16.6328 17.3847 16.5692 17.3311 16.5156ZM3.66852 8.8552C3.66852 7.82937 3.97271 6.82658 4.54263 5.97364C5.11255 5.12069 5.9226 4.4559 6.87035 4.06333C7.81809 3.67076 8.86096 3.56805 9.86708 3.76818C10.8732 3.96831 11.7974 4.46229 12.5227 5.18766C13.2481 5.91303 13.7421 6.83721 13.9422 7.84333C14.1424 8.84945 14.0396 9.89232 13.6471 10.8401C13.2545 11.7878 12.5897 12.5979 11.7368 13.1678C10.8838 13.7377 9.88103 14.0419 8.8552 14.0419C7.48008 14.0404 6.16171 13.4934 5.18935 12.5211C4.21699 11.5487 3.67004 10.2303 3.66852 8.8552Z"
      fill="currentColor"
    />
  </svg>
);
